import api from "../../api/api";
import type { StoresListResponse, StoresOrdering } from "../../types/types";

export interface GetStoresParams {
  search?: string;
  ordering?: StoresOrdering;
  page?: number;
  limit?: number;
}

// Public marketplace store listing: GET /stores/
// Auth not required, only active stores are returned.
export const getStores = async (
  params: GetStoresParams = {}
): Promise<StoresListResponse> => {
  const { search, ordering, page, limit } = params;
  const response = await api.get("/stores/", {
    params: {
      search: search || undefined,
      ordering: ordering || undefined,
      page,
      limit,
    },
  });
  return response.data;
};
